import environment from "../environment";

const push = (value: object): void => {
  if (environment.REACT_APP_ENVIRONMENT === "dev") {
    // tslint:disable-next-line:no-console
    console.log("analytics:", value);
  } else {
    // @ts-ignore
    window.dataLayer.push(value);
  }
};

export default { push };
